export type AdminClassificationUser = {
  id: string;
  activeOrganizationIds?: string[];
};

export type AdminClassificationMembership = {
  userId: string;
  organizationId?: string;
  removedAt?: string | null;
};

export function getUnassignedAdminUsers<T extends AdminClassificationUser>(
  users: T[],
  memberships: AdminClassificationMembership[]
): T[] {
  const usersWithMembership = new Set(
    memberships.map((membership) => membership.userId)
  );

  return users.filter((user) => {
    if ((user.activeOrganizationIds?.length ?? 0) > 0) {
      return false;
    }

    return !usersWithMembership.has(user.id);
  });
}
